var Request = require('../helper/request');

function Extension(app, groupId){
	var self = this;
	self.app = app;
	self.request = new Request(app);
	self.groupId = groupId;

	self.routes = {
		index: {
			url: "/message/group/"+self.groupId+"/extension",
			method: 'GET'
		},
		create: {
			url: "/message/group/"+self.groupId+"/extension",
			method: 'POST'
		}
	};
}

Extension.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

Extension.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		extension: data
	});
}

module.exports = Extension;